import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { 
  Package, ShoppingBag, LayoutDashboard, FileText, FolderTree, Settings, ArrowLeft, Tag, Loader2, Users
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const MENU_ITEMS = [
  { key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, path: '/admin' },
  { key: 'orders', label: 'Objednávky', icon: ShoppingBag, path: '/admin/objednavky' },
  { key: 'products', label: 'Produkty', icon: Package, path: '/admin/produkty' },
  { key: 'categories', label: 'Kategorie', icon: FolderTree, path: '/admin/kategorie' },
  { key: 'pages', label: 'CMS Stránky', icon: FileText, path: '/admin/stranky' },
  { key: 'coupons', label: 'Slevové kódy', icon: Tag, path: '/admin/kupony' },
  { key: 'customers', label: 'Zákazníci', icon: Users, path: '/admin/zakaznici' },
  { key: 'settings', label: 'Nastavení', icon: Settings, path: '/admin/nastaveni' },
];

export default function AdminLayout({ children, active }) {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && !user?.is_admin) navigate('/prihlaseni');
  }, [user, authLoading, navigate]);

  if (authLoading) return <div className="flex items-center justify-center min-h-[400px]"><Loader2 className="w-8 h-8 animate-spin text-[#004E98]" /></div>;

  return (
    <div className="min-h-screen bg-slate-100" data-testid="admin-layout">
      <div className="flex">
        <aside className="w-56 bg-slate-800 min-h-screen sticky top-0 flex-shrink-0">
          <div className="p-4 border-b border-slate-700">
            <Link to="/admin" className="text-white font-bold text-lg">Admin Panel</Link>
            <p className="text-slate-400 text-xs mt-0.5">E-shop Admin</p>
          </div>
          <nav className="p-2 space-y-0.5">
            {MENU_ITEMS.map(item => (
              <Link key={item.key} to={item.path} className={`flex items-center gap-3 px-3 py-2.5 rounded text-sm transition-colors ${active === item.key ? 'bg-[#004E98] text-white' : 'text-slate-300 hover:bg-slate-700 hover:text-white'}`} data-testid={`admin-nav-${item.key}`}>
                <item.icon className="w-4 h-4" />{item.label}
              </Link>
            ))}
          </nav>
          <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-slate-700">
            <Link to="/" className="flex items-center gap-2 text-slate-400 hover:text-white text-sm transition-colors"><ArrowLeft className="w-4 h-4" />Zpět do e-shopu</Link>
          </div>
        </aside>
        <main className="flex-1 p-6 min-w-0">{children}</main>
      </div>
    </div>
  );
}
